module.exports = __webpack_public_path__ + "media/images/e-kvitok/cabinet-c8004629ad6528700f66a38700bda6fd.svg";